import React, { useState, useEffect } from 'react'
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faCalendarDays, faEyeSlash, faEye } from "@fortawesome/free-solid-svg-icons";

const CssTextField = styled(TextField)({

    '& .MuiInputLabel-root': {
        fontSize: '0.9rem',
        color: '#666666',
        backgroundColor: "#fff",
        fontWeight: '500',
        padding: '0px 8px',
        top: '1px',
        left: '-11px',
        '& .required': {
            color: '#f00',
            paddingLeft: '2px',
            fontSize: '16px',
        },
        '&.Mui-disabled': {
            backgroundColor: '#f1f1f5',
        }
    },
    '& label.Mui-focused': {
        top: '2px',
        left: '-8px',
        color: '#0085FE',
    },

    '& .MuiInput-underline:after': {
        borderBottomColor: 'green',
    },

    '& .MuiOutlinedInput-root': {
        backgroundColor: "#fff",
        height: '40px',
        fontSize: '12px',
        fontWeight: '600',
        color: '#202020',

        '& fieldset': {
            borderColor: '#BABABA ',
        },
        '&:hover fieldset': {
            borderColor: '#a6a8ab',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#0085FE',
        },

        '& input[type=number]': {
            'MozAppearance': 'textfield',
        },
        '& input[type=number]::-webkit-outer-spin-button': {
            'WebkitAppearance': 'none',
            margin: 0
        },
        '& input[type=number]::-webkit-inner-spin-button': {
            'WebkitAppearance': 'none',
            margin: 0
        },
        "&.Mui-disabled": {
            backgroundColor: "#F1F1F1",
            color: "#202020 !important",
        },
        '&.Mui-disabled fieldset': {
            borderColor: '#BABABA ',
        },
    },
    '& .MuiOutlinedInput-input': {
        fontSize: '14px',
        padding: '8.5px 12px',
        // '&[type=number]': {
        //     paddingLeft: '9px !important',
        // },
        "&.Mui-disabled": {
            backgroundColor: "#F1F1F1",
            color: "#202020 !important",
            WebkitTextFillColor: '#202020 !important'
        },
    },
    '& .MuiInputLabel-root.Mui-disabled:not(.MuiInputLabel-shrink)': {
        backgroundColor: 'transparent',
        padding: '0px',
        left: '0px'
    },
    '& .MuiFormLabel-filled': {
        backgroundColor: '#fff',
        padding: '0px 8px',
        top: '2px',
        left: '-8px',
    },
    '& .MuiOutlinedInput-input::placeholder': {
        color: '#666666',
    },

    '& .MuiOutlinedInput-input.Mui-disabled::placeholder': {
        color: '#BDBDBD',
    }
});


function TextBox(props) {

    const { type = 'text', label = "", value = '', id = '', onChange = null, disabled = false, name, isCompulsory = false, calIcon = false, rssign = false, textBoxRef, adornment, style, onBlur = null, inUpperCase = false, maxLength = '', placeholder = '', regePattern = "", isSpecficText = false, onKeyDown = () => { }, onDoubleClick = null, onClick = null, isPassWord = false } = props;

    const [inputValue, setInputValue] = useState(null);
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        if (value !== inputValue) {
            setInputValue(inUpperCase ? value.toString()?.toUpperCase() : value);
        }
    }, [value])

    const handleInputOnChange = (e) => {
        let newVal = inUpperCase ? e.target.value.toString()?.toUpperCase() : e.target.value
        if (isSpecficText && regePattern !== '') {
            let checkText = new RegExp(regePattern);
            if (!checkText.test(newVal) && newVal.trim() !== '') {
                return;
            }
        }
        if (onChange) {
            if (maxLength) {
                if (newVal.length <= maxLength) {
                    setInputValue(newVal);
                    onChange(e, newVal)
                }
            } else {
                setInputValue(newVal);
                onChange(e, newVal)
            }
        }
    }
    const handleInputOnBlur = (e) => {
        let newVal = inUpperCase ? e.target.value.toString()?.toUpperCase() : e.target.value;
        if (isSpecficText && regePattern !== '') {
            let checkText = new RegExp(regePattern);
            if (checkText.test(newVal)) {
                setInputValue(newVal);
                if (onBlur) {
                    const syntheticEvent = { target: { value: newVal, name: e.target.name, }, };
                    onBlur(syntheticEvent, newVal);
                }
            }
        } else {
            setInputValue(newVal);
            if (onBlur) {
                const syntheticEvent = { target: { value: newVal, name: e.target.name, }, };
                onBlur(syntheticEvent, newVal);
            }
        }
    };

    const labelTxt =
        isCompulsory ? (
            <span>
                {label}
                <span style={{ color: "red", paddingLeft: "5px" }}>*</span>
            </span>
        ) : (
            label
        );

    const clearInput = (e) => {
        setInputValue('');
        if (onChange) {
            onChange(e)
        }
    }

    const handleWheel = (e) => {
        if (type === "number") {
            e.preventDefault(); // Prevent default behavior of scrolling changing the value
            e.target.blur();
        }
    };
    return (
        <CssTextField
            fullWidth
            type={isPassWord && !showPassword ? "password" : type} // 👈 toggle visibility
            name={name}
            id={id !== '' ? id : name}
            label={labelTxt}
            disabled={disabled}
            value={inputValue}
            onChange={handleInputOnChange}
            placeholder={placeholder}
            onBlur={handleInputOnBlur} // Attach onBlur
            size="small"
            inputRef={textBoxRef}
            sx={style}
            onWheel={handleWheel}
            onKeyDown={(e) => {
                if (type === "number") {
                    if (e.key === '-' || e.key === '+' || e.key === 'e') {
                        e.preventDefault();
                    }
                }
                // e.stopPropagation()
                onKeyDown && onKeyDown(e);
            }}
            onDoubleClick={(e) => {
                e.stopPropagation()
                onDoubleClick && onDoubleClick(e);
            }}

            InputProps={{
                autoComplete: "off",
                classes: {
                    disabled: "disabled",
                },
                startAdornment: (
                    adornment
                        ? calIcon
                            ? <InputAdornment position="start">
                                <FontAwesomeIcon
                                    icon={faCalendarDays}
                                    className="cross"
                                    style={{ fontSize: "18px" }}
                                    color={"#0085fe"}
                                />
                            </InputAdornment>
                            : rssign
                                ? "Rs"
                                : null
                        : null
                ),
                endAdornment: (
                    isPassWord && !disabled ?
                        <InputAdornment position="end">
                            <FontAwesomeIcon
                                icon={showPassword ? faEyeSlash : faEye}
                                onClick={() => setShowPassword((prev) => !prev)}
                                style={{ cursor: "pointer", fontSize: "16px", marginLeft: "5px" }}
                            />
                        </InputAdornment> :
                        adornment
                            ? disabled
                                ? null
                                : <InputAdornment position="end">
                                    {inputValue && inputValue.length > 0 &&
                                        <div className="cross--icon" style={{ cursor: 'pointer' }}>
                                            <FontAwesomeIcon icon={faXmark} className="cross" onClick={clearInput} />
                                        </div>
                                    }
                                </InputAdornment>
                            : null
                )
            }}
            inputProps={{
                ...(type === "number"
                    ? { max: maxLength }
                    : { maxLength: maxLength }
                ),
                onClick: (e) => {
                    e.stopPropagation();
                    onClick && onClick(e);
                }
            }}

        />
    )
}

export default TextBox;